















import { defineComponent } from "@vue/composition-api";
import { MassMessage } from "@scrile/api-provider/dist/api/MassMessageProvider";
import { PaymentPackageMap, RecipientsCountMap } from "@/views/PageScheduledMassMessage/type";
import ScheduledMassMessageStatItem from "../ScheduledMassMessageStatItem";

export default defineComponent({
  name: "ScheduledMassMessageStatView",
  components: { ScheduledMassMessageStatItem },
  props: {
    massMessages: { type: Array as () => MassMessage[], default: () => [] as MassMessage[] },
    paymentPackageMap: { type: Object as () => PaymentPackageMap },
    recipientsCountMap: { type: Object as () => RecipientsCountMap },
  },
});
